export enum MutationTypes {
    SET_REPORTS = 'reports-module/set-reports',
    SET_REPORTS_META = 'reports-module/set-reports-meta',
    SET_REPORT = 'reports-module/set-report',
    SET_PDF = 'reports-module/set-pdf',
}
